import React, { useEffect, useState } from "react";
import { Title } from "../../../../stories/Title/Title";
import Input from "../../../../stories/Input/Input";
import { Button } from "../../../../stories/Button/Button";

import NoData from "../../../../images/NoData.svg";
import { useNavigate } from "react-router-dom";
import useToken from "../../../../customHooks/useToken";
import useUrlParams from "../../../../customHooks/useUrlParams";
import {
  AtsStckPurchaseItemsEdge,
  AtsStckPurchaseItemsField,
  GetPurchaseItemsResult,
  GetPurchaseItemsVar,
  PurchaseItemFilterTypes
} from "./queries/types";
import { useLazyQuery } from "@apollo/client";
import { PurchaseItems } from "./queries/queries";
import Compare from "../../../../images/Compare.svg";
import LoadingModal from "../../../pages/LoadingModal";
import { ROWS_PER_PAGE } from "../../../../utils/constants";
import { OrderDirection } from "../../../../utils/commonQueryTypes";
import {
  labelClasses,
  LabeledAutocomplete
} from "../../../../styles/AutocompleteStyles";
import { Keys, SpecialKeys } from "../../../../utils/Enum.keys";
import {
  CustomModal,
  handleMUISelectEvent,
  toInputStandardDate
} from "../../../../utils/UtilFunctions";
import { TextField } from "@mui/material";
import { formDates } from "./material/ApprovedList";
import useServerDateandTime from "../../../../customHooks/useServerDateandTime";
import RightArrow from "../../../../images/ArrowRight.svg";
import Edit from "../../../../images/EditProfile.svg";
import Delete from "../../../../images/Delete.svg";
import { AddModalStyles } from "../../../../styles/CustomModalStyles";
import ViewPurchaseItem from "./ViewPurchaseItem";
import Approved from "../../../../images/ApprovedRequest.svg";
import Rejected from "../../../../images/RejectedRequest.svg";
import Navbar from "../../../common/layout/Navbar";
import { LicenseTypes } from "../../../../utils/Enum.types";
import { useHotKey } from "../../../../utils/hotKeys";
import useLabels from "../../../../customHooks/useLabels";

const Index = () => {
  const navigate = useNavigate();
  const { customer_id,company_id } = useUrlParams();
  const { handleToken } = useToken();
  const [searchData, setSearchData] = useState("");
  const [filterStatus, setFilterStatus] = useState(
    PurchaseItemFilterTypes.ALL_ITEMS
  );
  const statusOptions = Object.values(PurchaseItemFilterTypes);
  const formatText = (input: string) => {
    return input
      .replace(/_/g, " ")
      .replace("/\bw/g", (char) => char.toUpperCase());
  };
  const [dates, setDates] = useState<formDates>({
    startDate: "",
    endDate: ""
  });
  const [editModal, setEditModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [purchaseItems, setPurchaseItems] = useState<
    AtsStckPurchaseItemsEdge[]
  >([]);

  const { data: todaysDateData, serverDate } = useServerDateandTime();

  useEffect(() => {
    if (todaysDateData && serverDate) {
      const getMonth = new Date(serverDate).getMonth();
      const getYear = new Date(serverDate).getFullYear();

      const firstDay = new Date(getYear, getMonth, 1); // First day of the month
      const lastDay = new Date(getYear, getMonth + 1, 0);

      setDates({
        endDate: lastDay.toString(),
        startDate: firstDay.toString()
      });
    }
  }, [todaysDateData, serverDate]);
  const [GetPurchaseItems, { data, loading, fetchMore }] = useLazyQuery<
    GetPurchaseItemsResult,
    GetPurchaseItemsVar
  >(PurchaseItems);

  useEffect(() => {
    const fetchPurchaseItems = async () => {
      try {
        const token = await handleToken();
        if (token && customer_id) {
          await GetPurchaseItems({
            variables: {
              after: null,
              customer_id,
              first: ROWS_PER_PAGE,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsStckPurchaseItemsField.DESC
              },
              token,
              name: searchData
            }
          });
        }
      } catch (error) {
        console.error((error as Error).message);
      }
      fetchPurchaseItems();
    };
  }, [customer_id, GetPurchaseItems, searchData]);

  useHotKey({
    handleFunc: () => {
      navigate(`/assets/purchase/${customer_id}/add`)
    },
    specialCharacter: SpecialKeys.CTRL,
    charater: "a",
  });
const {itemLabel,subsidiaryLabel,ledgerLabel}=useLabels();
const Data = [
  {
    title: "Date",
    value: "12-11-2024"
  },
  {
    title: `${subsidiaryLabel}`,
    value: "Demo company"
  },
  {
    title: "Requested By",
    value: "user"
  },
  {
    title: `${ledgerLabel}`,
    value: "Praveen Technologies"
  },
  {
    title: "GST No.",
    value: "22AAA0000z5"
  },
  {
    title: "Total Quantity Requested",
    value: 20
  },
  {
    title: "Net Amount",
    value: 0
  }
];
  return (
    <>
      <Navbar NavType={LicenseTypes.COMPANY} /> <Title>Purchase {itemLabel}</Title>
      <div className="purchase">
        <div className="purchase__search row g-0">
          <div className="col-2">
            <Input id="data_search" placeholder="Search..." />
          </div>
          <div className="col-2">
            <LabeledAutocomplete
              className={labelClasses.inputRoot}
              options={statusOptions}
              getOptionLabel={(option) => {
                return formatText(option as string);
              }}
              value={filterStatus}
              onKeyDown={(e) => {
                if (e.key === Keys.ENTER) {
                  e.preventDefault();
                  handleMUISelectEvent(e);
                }
              }}
              onChange={(event, newValue) =>
                setFilterStatus(newValue as PurchaseItemFilterTypes)
              }
              openOnFocus
              forcePopupIcon
              renderInput={(params) => (
                <TextField
                  {...params}
                  fullWidth
                  className={labelClasses.formControlRoot}
                  label="Status"
                  slotProps={{
                    inputLabel: {
                      shrink: true
                    }
                  }}
                />
              )}
            />
          </div>
          <div className="col-4 purchase__search--flex">
            <TextField
              label="Start Date"
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              type="date"
              className=" material__select--date"
              value={toInputStandardDate(dates.startDate)}
              onChange={(e) => {
                setDates({
                  ...dates,
                  startDate: e.target.value
                });
              }}
            />
            <img src={Compare} alt="" className="purchase__search--image" />
            <TextField
              label="End Date"
              type="date"
              slotProps={{
                inputLabel: {
                  shrink: true
                }
              }}
              className=" material__select--date"
              value={toInputStandardDate(dates.endDate)}
              onChange={(e) => {
                setDates({
                  ...dates,
                  endDate: e.target.value
                });
              }}
            />
          </div>
          <div className="col flex-end">
            <Button
              mode="addnew"
              onClick={() => navigate(`/${customer_id}/company/${company_id}/purchase/add`)}
            />
          </div>
        </div>
        <div className="purchase__datablock">
          <div
            className="purchase__datablock--header"
            id={`${
              filterStatus === PurchaseItemFilterTypes.PENDING_ITEMS
                ? "bg-grey"
                : filterStatus === PurchaseItemFilterTypes.IN_PROGRESS_ITEMS
                ? "bg-amber"
                : filterStatus === PurchaseItemFilterTypes.REJECTED_ITEMS
                ? "bg-red"
                : filterStatus === PurchaseItemFilterTypes.APPROVED_ITEMS
                ? "bg-green"
                : "bg-var"
            }`}
          >
            <span>
              {`Total ${
                filterStatus !== PurchaseItemFilterTypes.ALL_ITEMS
                  ? filterStatus
                  : "All"
              } Requests`}
              :
            </span>
            <b>{data ? data.GetPurchaseItems.totalCount : 0}</b>
          </div>
          <ul className="purchase__datablock--ul">
            {/* {data ?  data.GetPurchaseItems.edges.map((res,index)=>{
            return ( */}
            <li className="purchase__datablock--li">
              <span>1.</span>
              <div
                className="purchase__datablock--li--left"
                onClick={() => setViewModal(!viewModal)}
              >
                <div className="purchase__datablock--li--header">
                  <b>INV001</b>
                  <span
                    className={`material__list--li--flex${
                      filterStatus === PurchaseItemFilterTypes.APPROVED_ITEMS
                        ? "--approved"
                        : filterStatus ===
                          PurchaseItemFilterTypes.IN_PROGRESS_ITEMS
                        ? "--progress"
                        : filterStatus ===
                          PurchaseItemFilterTypes.REJECTED_ITEMS
                        ? "--rejected"
                        : filterStatus === PurchaseItemFilterTypes.ALL_ITEMS
                        ? "--all"
                        : "--pending"
                    }`}
                  >
                    {filterStatus}
                  </span>
                </div>

                <div className="purchase__datablock--li--grid">
                  {Data.map((label, index) => {
                    return (
                      <div>
                        <span>{label.title}</span>
                        <b>{label.value}</b>
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="purchase__datablock--li--actions">
                <div>
                  <span>Actions</span>
                  <div className="purchase__datablock--li--actions--flex">
                    <img src={Edit} alt="" />
                    <img src={Delete} alt="" />
                  </div>
                </div>
                <img src={RightArrow} alt="" />
              </div>
            </li>
            {/* )
          }):  <img src={NoData} alt="" className="nodata-image" />} */}
          </ul>
        </div>
        <div className="row g-0">
          <div className="col">
            <Button mode="back" onClick={() => navigate(-1)} />
          </div>
          <div className="col material__footer">
            <div>
              <img src={Approved} alt="" />
              <span className="font-green">0</span>
            </div>
            <div>
              <img src={Rejected} alt="" />
              <span className="font-red">0</span>
            </div>
          </div>
        </div>
      </div>
      <LoadingModal flag={loading} />
      <CustomModal
        isOpen={viewModal}
        onRequestClose={() => setViewModal(!viewModal)}
        contentComponent={<ViewPurchaseItem setModalFlag={setViewModal} />}
        style={AddModalStyles}
      />
    </>
  );
};

export default Index;
